/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsApiHistoryItem
 */
export interface ControlcenterMelcoModelsApiHistoryItem {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsApiHistoryItem
     */
    name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsApiHistoryItem
     */
    modified_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsApiHistoryItem
     */
    json?: string | null;
}

export function ControlcenterMelcoModelsApiHistoryItemFromJSON(json: any): ControlcenterMelcoModelsApiHistoryItem {
    return ControlcenterMelcoModelsApiHistoryItemFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsApiHistoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsApiHistoryItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'modified_date': !exists(json, 'modified_date') ? undefined : (json['modified_date'] === null ? null : new Date(json['modified_date'])),
        'json': !exists(json, 'json') ? undefined : json['json'],
    };
}

export function ControlcenterMelcoModelsApiHistoryItemToJSON(value?: ControlcenterMelcoModelsApiHistoryItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'modified_date': value.modified_date === undefined ? undefined : (value.modified_date === null ? null : value.modified_date.toISOString()),
        'json': value.json,
    };
}


